import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getFloorIdFromLocation = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.floorId || null);

export default getFloorIdFromLocation;
